import React from "react";
import { Settings } from "@store/types";
import { State, getSettings } from "@store";
import { useSelector, useDispatch } from "react-redux";

type Data<T> = [T, Error | null, boolean];

export function useSettings(): Data<Settings> {
  const dispatch = useDispatch();
  const [settings, error, fetching] = useSelector((state: State) => [
    state.settings,
    state.network.error.settings,
    state.network.fetching.settings,
  ]);

  React.useEffect(() => {
    if (!settings && !error && !fetching) {
      dispatch(getSettings());
    }
  }, [dispatch, settings, error, fetching]);

  return [settings, error, fetching];
}
